import { Injectable } from '@angular/core';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';

// extra keys for Relationship Manager
const RM_TOKEN_KEY = 'rm-token';
const RM_USER_KEY = 'rm-user';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor() {}

  signOut(): void {
    window.localStorage.clear();
  }

  // ----- Default token -----
  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return window.localStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  // ----- Relationship Manager token -----
  public saveRmToken(token: string): void {
    window.localStorage.removeItem(RM_TOKEN_KEY);
    window.localStorage.setItem(RM_TOKEN_KEY, token);
  }

  public getRmToken(): string | null {
    return window.localStorage.getItem(RM_TOKEN_KEY);
  }

  public saveRmUser(user: any): void {
    window.localStorage.removeItem(RM_USER_KEY);
    window.localStorage.setItem(RM_USER_KEY, JSON.stringify(user));
  }

  public getRmUser(): any {
    const user = window.localStorage.getItem(RM_USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public getUserModules(): string[] {
    const user = this.getUser();
    if (user && user.permissions) {
      return Object.keys(user.permissions);
    }
    return [];
  }

  public getUserPermissions(): { [module: string]: any[] } {
    const user = this.getUser();
    return user?.permissions || {};
  }
}
